import { ENTITIES } from "./actionConstants.js";

import { getEntity } from "./actionUtils.js";

// -- GENERIC ENTITY ACTIONS -- //

// this is a little confusing at the moment as we switch to using a generic ENTITIES store
// should be much clearer once we're done

export const getEntityAction = (id, options, dependencies) => {
  // console.log(
  //   "getEntityAction NEW: id:",
  //   id,
  //   "options:",
  //   options,
  //   "dependencies:",
  //   dependencies
  // );
  return getEntity(ENTITIES, id, options, dependencies);
};
